export enum DiagramActionType {
  Create = 'create',
  Edit = 'edit'
}
